<template>
    <button class='button' :style='[compiled_styles, custom_styles.layer]' type="button" :id='layer.id' v-html='layer.config.text' :class="[classes.layer]" @click='buttonClick'></button>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    props: ['layer', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            compiled_styles:{},
            classes: {}
        }
    },
    methods:{
        buttonClick(){
            if(typeof this.layer.config.url !== 'undefined'){
                if(this.layer.config.url !== '' && !this.page_builder_mode){
                    if(this.layer.config.url_type != 'external'){
                        this.$router.push(this.layer.config.url);
                    }
                    else{
                        window.location.href = this.layer.config.url;
                    }
                }
            }
        },
        setStyles(){
            if(this.layer.compiled_styles != null){
                this.compiled_styles =this.layer.compiled_styles.button;
            }
            
            if(this.layer.compiled_classes != null){
                this.classes = this.layer.compiled_classes;
            }

            // Object.keys(this.layer.button_styles).forEach(key => {
            //     const value = this.layer.button_styles[key];
            //     this.styles[value.css_property] = value.value;
            // });
        }
    },
    watch:{
       'layer': {
            handler(){
                this.setStyles();
                this.setCustomCssStyles(this.layer.custom_styles); //From mixin
            },
            deep: true
        }
    },
    mounted(){
        this.setStyles()
        this.setCustomCssStyles(this.layer.custom_styles); //From mixin
    }

}
</script>

<style lang="scss" scoped>
.button{
    color: #f8f9fa;
    padding: 12px 20px;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
    width: 100%;
    border: none;
    background-color: transparent;
}

</style>
